import React from "react";
import StepZilla from "react-stepzilla";
import HeaderLogin from ".././../HeaderLogin/HeaderLogin.jsx";
import PersonalInfo from ".././Steps/PersonalInfo";
import UpdatepersonalInfo from "./steps/updatepersonalInfo.jsx";
import CompanyInfo from ".././Steps/CompanyInfo";
import BillingInfo from "./steps/BillingInfo.jsx";
import CheckoutForm from "./steps/CheckOutForm";
import Review from "./steps/Review";
import { connect } from "react-redux";
import {
  registerUserAction,
  getInviteUserDetailAction,
  registerUserWithBillingAction,
  registerUserWithoutPlanAction,
  getStripeSettingAction,
  getBillingSettingAction,
  registerInvitedAccounowner,
} from ".././../../actions/UserActions";
import { getAllSubscriptionAction } from ".././../../actions/SubscriptionAction";
import { getAddressFromZipcodeAction } from ".././../../actions/commonActions";
import {
  cryptoTokenDecode,
  getToday,
  removeDashFromMobile,
  toastMessage,
  formatPhoneNumber,
} from ".././../Common/Common";
import $ from "jquery";
import * as code from ".././../../config/Constants";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import * as message from ".././../../config/CommonMessages";
import { getHearAboutUsAction } from "../../../actions/HearAboutUsActions";
import APIUtil from "../../../config/APIUtil";
import UrlConstants from "../../../config/UrlConstants";
import { Link } from "react-router-dom";
import { getStripeKeyAction } from ".././../../actions/PaymentMethodActions";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants.jsx";
var CryptoJS = require("crypto-js");

var date = getToday();
//const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class Register extends React.Component {
  // Where ACCTOWNER gets read into system
  // usertype needs to be an array
  defaultState = {
    username: "",
    usertype: message.ACCTOWNER,
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobileNumber: "",
    regMsgDisplay: false,
    agentPercent: 100.0,
    brokerPercent: 0.0,
    paymentMethodId: "",
    paymentMethods: {
      number: "",
      expireMonth: "",
      expireYear: "",
      brand: "",
    },
    billingAddress: {
      firstname: "",
      lastname: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      phoneNumber: "",
    },
    showNavigation: true,
    authId: "",
    showLoader: false,
    key: null,
    userId: window.location.href.split("/")[5],
    ispaymentMethodAdded: false,
    stripePromise: "",
  };
  constructor(props) {
    super(props);
    this.state = this.defaultState;
  }

  getUserData() {
    return this.state;
  }

  updateUserData(key, value, isUpdate) {
    this.setState(
      {
        [key]: value,
      },
      () => {
        if (isUpdate) {
          this.setState({ key: new Date() });
        }
      }
    );

    // console.log(`===============key====================`, key);
    // console.log("==key${value}===", value);
  }

  updateUserCmpnyData(key, value) {}
  updateSocialMediaHandles(key, value) {}
  updateUserBillingData(key, value) {
    var billing = this.state.billingAddress;
    billing[key] = value;
    this.setState({ billingAddress: billing });
  }
  componentWillMount() {
    this.getReactAppStripeKey();
    // remove localstorage data if not came from pricing screen
    //this.stripeSettingAction();
    this.billingSettingAction();
  }
  componentDidMount() {
    this.setUserData();
    // if (localStorage.getItem(code.IS_STRIPE_ENABLED) === "true") {
    //   this.getPlanDetails();
    // }
    // this.props.getHearAboutUsAction();
  }

  getReactAppStripeKey() {
    this.setState({ showLoader: true });
    this.props.getStripeKeyAction().then((res) => {
      //console.log('getReactAppStripeKey getStripeKeyAction res',res);
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        var sKey = res.data;
        //console.log('getReactAppStripeKey OK sKey', sKey);
        let bytes = CryptoJS.AES.decrypt(sKey, REACT_APP_CRYPTO_SECRET_KEY);
        //console.log('getReactAppStripeKey OK bytes', bytes);
        let decryptedDataKey = bytes.toString(CryptoJS.enc.Utf8);
        //console.log('decryptedDataKey',decryptedDataKey);
        let stripePromise = loadStripe(decryptedDataKey);
        this.setState({ stripePromise });
      }
    });
  }

  // getPlanDetails() {
  //   this.props.getAllSubscriptionAction("month").then((monthRes) => {
  //     if (monthRes.status === code.OK) {
  //       this.setState({ monthData: monthRes.data });
  //       this.setPriceData(this.state.price);
  //     }
  //   });
  //   this.props.getAllSubscriptionAction("year").then((yearRes) => {
  //     if (yearRes.status === code.OK) {
  //       this.setState({ yearData: yearRes.data });
  //       this.setPriceData(this.state.price);
  //     }
  //   });
  // }

  /** set user data if user registered by admin */
  setUserData() {
    // let token = "";
    // if (this.props.match.params.token) {
    //   token = this.props.match.params.token;
    //   this.setState({ token, showLoader: true });
    //   localStorage.setItem("token", token);
    //   this.props.getInviteUserDetailAction(token).then((res) => {
    //     if (res.status === code.OK) {
    //       let resKeys = Object.keys(res.data);
    //       let resValues = Object.values(res.data);
    //       for (let i = 0; i < resKeys.length; i++) {
    //         if (resKeys[i] === "email") {
    //           this.updateUserData(resKeys[i], resValues[i].address, true);
    //           this.updateUserData("recoveryEmail", resValues[i].address, true);
    //         } else if (resKeys[i] === "subsriptionDetails") {
    //           this.updateUserData("price", resValues[i].priceId, true);
    //           this.setPriceData(resValues[i].priceId);
    //           localStorage.setItem("price", resValues[i].priceId, true);
    //         } else if (resKeys[i] === "otherNumber") {
    //           this.updateUserData(
    //             resKeys[i],
    //             resValues[i] == null
    //               ? ""
    //               : formatPhoneNumber(resValues[i].toString()),
    //             true
    //           );
    //         } else if (resKeys[i] === "mobileNumber") {
    //           this.updateUserData(
    //             resKeys[i],
    //             formatPhoneNumber(resValues[i].toString()),
    //             true
    //           );
    //         } else if (resKeys[i] === "agentPercentage") {
    //           this.updateUserData("agentPercent", resValues[i], true);
    //         } else if (resKeys[i] === "brokerPercentage") {
    //           this.updateUserData("brokerPercent", resValues[i], true);
    //         } else if (resKeys[i] === "companyInformation") {
    //           let keys = Object.keys(res.data.companyInformation);
    //           let values = Object.values(res.data.companyInformation);
    //           for (let k = 0; k < keys.length; k++) {
    //             if (keys[k] === "phoneNumber") {
    //               this.updateUserCmpnyData(
    //                 keys[k],
    //                 formatPhoneNumber(values[k].toString())
    //               );
    //             } else {
    //               this.updateUserCmpnyData(keys[k], values[k]);
    //             }
    //           }
    //         } else if (resKeys[i] === "socialMediaHandles") {
    //           let keys = Object.keys(res.data.socialMediaHandles);
    //           let values = Object.values(res.data.socialMediaHandles);
    //           for (let k = 0; k < keys.length; k++) {
    //             this.updateSocialMediaHandles(keys[k], values[k]);
    //           }
    //           this.setState({ showLoader: false });
    //         } else {
    //           this.updateUserData(resKeys[i], resValues[i], true);
    //         }
    //       }
    //     } else {
    //       this.setState({ showLoader: false });
    //     }
    //   });
    // } else {
    //   localStorage.removeItem("token");
    // }

    // const response = await axios.get(
    //   `${UrlConstants.RegisterUrl}/getuserbyid/${id}`
    // );

    APIUtil.getMethod(
      `${UrlConstants.RegisterUrl}/getuserbyid/${this.state.userId}`,
      false
    ).then((response) => {
      // console.log("response273", response);
      if (response.status == 200) {
        // set state
        this.updateUserData("firstname", response.data.firstname, true);
        this.updateUserData("lastname", response.data.lastname, true);
        this.updateUserData(
          "mobileNumber",
          String(response.data.mobileNumber),
          true
        );
        this.updateUserData("email", response.data.email.address, true);
        this.updateUserData("authId", response.data.authId, true);
        this.updateUserData(
          "ispaymentMethodAdded",
          response.data.ispaymentMethodAdded,
          true
        );
      } else {
        // please open not authorized page
      }
    });
  }

  billingSettingAction() {
    this.props.getBillingSettingAction().then((res) => {
      if (res.status === code.OK) {
        if (res.data.isBillingEnabled) {
          localStorage.setItem(code.IS_BILLING_ENABLED, "true");
        } else {
          localStorage.setItem(code.IS_BILLING_ENABLED, "false");
        }
        this.setState({ showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    });
  }

  setPriceData(priceId) {
    // this.state.monthData.filter((monthData) => {
    //   Object.keys(monthData).forEach((v) => {
    //     if (v === "price") {
    //       let price = monthData[v].price + "";
    //       if (price === priceId) {
    //         this.setProductData(monthData);
    //       }
    //     }
    //   });
    // });
    // this.state.yearData.filter((yearData) => {
    //   Object.keys(yearData).forEach((v) => {
    //     if (v === "price") {
    //       let price = yearData[v].price + "";
    //       if (price === priceId) {
    //         this.setProductData(yearData);
    //       }
    //     }
    //   });
    // });
  }
  /**
   * @desc update user data
   * @param {*} data
   */
  // setProductData(data) {
  //   this.updateUserData("productName", data.name);
  //   this.updateUserData("amount", data.price.unit_amount);
  //   this.updateUserData("interval", data.price.recurring.interval);
  // }
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  getLastStep(step) {
    this.setState({ regMsgDisplay: false, showLoader: true });
    // console.log("nextcalling");
    if (localStorage.getItem(code.IS_BILLING_ENABLED) === "true") {
      // if (step === 0 || step === 1 || step === 2 || step === 3) {
      //   $(".saveBtn").html("Next");
      // }
      if (step === 0 || step === 1) {
        $(".saveBtn").html("Next");
        this.setState({ showLoader: false });
      }

      // if (step === 3) {
      //   if (
      //     localStorage.getItem("price") === "" ||
      //     localStorage.getItem("price") == undefined
      //   ) {
      //     toastMessage(code.ERROR, message.SELECT_YOUR_PLAN);
      //     $("#prev-button").trigger("click");
      //   }
      // }
      //if (step === 4) {
      if (step === 2) {
        this.setState({ showNavigation: false });
        this.setState({ showLoader: false });
      } else {
        this.setState({ showNavigation: true });
        this.setState({ showLoader: false });
      }
      //if (step === 5) {
      if (step === 3) {
        $(".saveBtn").html("Confirm & Save");
        this.setState({ showLoader: false });
      }
      //if (step === 6) {
      if (step === 4) {
        this.submitAction();
      }
    }
  }
  nextButtonClick() {
    $("#next-button").trigger("click");
  }
  perviousButtonClick() {
    $("#prev-button").trigger("click");
  }
  getPaymentData(paymentMethod) {
    this.setState((prevState) => ({
      paymentMethods: {
        ...prevState.paymentMethods,
        brand: paymentMethod.card.brand,
        expireMonth: paymentMethod.card.exp_month,
        expireYear: paymentMethod.card.exp_year,
        number: paymentMethod.card.last4,
      },
    }));
    this.setState({ paymentMethodId: paymentMethod.id });
  }

  submitAction() {
    let data = this.state;
    delete data.confirmPassword;
    delete data.showNavigation;
    delete data.token;
    data.mobileNumber = removeDashFromMobile(data.mobileNumber);

    data.billingAddress.phoneNumber = removeDashFromMobile(
      data.billingAddress.phoneNumber
    );

    data.agentPercent = data.agentPercent;
    data.brokerPercent = data.brokerPercent;

    //email should be in lowercase while sending to api
    data.email = data.email.toLowerCase();
    data.username = data.username.toLowerCase();

    //trim the data
    data.username = data.username.trim();
    data.firstname = data.firstname.trim();
    data.lastname = data.lastname.trim();
    data.email = data.email.trim();
    data.password = data.password.trim();
    delete data.agentPercent;
    delete data.brokerPercent;
    delete data.regMsgDisplay;

    if (localStorage.getItem(code.IS_BILLING_ENABLED) === "true") {
      this.setState({ showLoader: true });
      this.props.registerInvitedAccounowner(data).then((res) => {
        this.setState({ showLoader: false });
        // console.log("res", res);
        if (res.status === 200) {
          if (res.data.statusCode === 200) {
            this.props.history.push({
              pathname: "/thankyou",
            });
            this.setState({ regMsgDisplay: true, showLoader: false });
          } else {
            toastMessage(code.ERROR, res.data.error);
            this.setState({ regMsgDisplay: true, showLoader: false });
          }
        } else {
          toastMessage(code.ERROR, res.data);
          this.setState({ regMsgDisplay: true });
        }
      });
    }
  }

  checkLoggedIn() {
    let userType = cryptoTokenDecode().usertype;
    if (userType !== null && userType.toUpperCase() === message.ADMIN) {
      this.props.history.push("/RegistrationRequests");
    } else {
      this.props.history.push("/artwork");
    }
  }

  render() {
    // console.log("defaultState", this.state);
    $("#next-button").attr("tabIndex", -1);

    if (localStorage.getItem("accessToken")) {
      this.checkLoggedIn();
    }

    var cls = "multi-step multi-step-register";
    if (this.state.regMsgDisplay === true && this.props.status === true) {
      cls = "multi-step multi-step-register error";
    }

    if (this.state.regMsgDisplay === true && this.props.status === false) {
      cls = "multi-step multi-step-register error";
    }

    const steps = [
      {
        name: "Personal Info",
        component: (
          <UpdatepersonalInfo
            getUserData={() => this.getUserData()}
            updateUserData={(k, v) => {
              this.updateUserData(k, v);
            }}
          />
        ),
      },
      {
        name: "Billing Info",
        component: (
          <BillingInfo
            getUserData={() => this.getUserData()}
            updateUserData={(k, v) => {
              this.updateUserBillingData(k, v);
            }}
            getCityState={(zip) => this.props.getAddressFromZipcodeAction(zip)}
            getPaymentData={(data) => {
              this.getPaymentData(data);
            }}
          />
        ),
      },
      {
        name: "Payment Info",
        component: (
          <Elements stripe={this.state.stripePromise}>
            <CheckoutForm
              getPaymentData={(data) => {
                this.getPaymentData(data);
              }}
              nextButtonClick={this.nextButtonClick}
              perviousButtonClick={this.perviousButtonClick}
              getUserData={() => this.getUserData()}
              updateUserData={(k, v) => {
                this.updateUserData(k, v);
              }}
            />
          </Elements>
        ),
      },
      {
        name: "Review",
        component: <Review getUserData={() => this.getUserData()} />,
      },
    ];

    return (
      <>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        {this.state.authId === "" || !this.state.ispaymentMethodAdded ? (
          <div className="reg-page">
            <HeaderLogin />
            <div className="loginBg">
              <div className="step-progress">
                <div className="reg-title-wrapper">
                  <h4 className="title-big mt-0 pt-2">Create Your Account</h4>
                </div>

                <div className={cls}>
                  <StepZilla
                    steps={steps}
                    // showNavigation={true}
                    backButtonCls="btn btn-sm btn-primary btn-blue btn-outlined w-140 mr-3"
                    nextButtonCls="btn btn-sm btn-primary btn-blue w-140 saveBtn"
                    onStepChange={(step) => this.getLastStep(step)}
                    showNavigation={this.state.showNavigation}
                    //hocValidationAppliedTo={[0, 1, 3]}
                    hocValidationAppliedTo={[0, 1]}
                    key={this.state.key}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="step-content">
              <div className="loginBox">
                <div role="alert" class="fade alert alert-success show">
                  You have already registered with us. Please login with your
                  set account credentials.
                </div>{" "}
                <Link style={{ color: "#4a90e2" }} to="/login">
                  Click here to go to login
                </Link>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    status: state.reducer.status,
    RegMessage: state.reducer.RegMessage,
    hearAboutUs: state.reducer.hearAboutUs,
  };
};

export default connect(
  mapStateToProps,
  {
    registerUserAction,
    getAddressFromZipcodeAction,
    getAllSubscriptionAction,
    getInviteUserDetailAction,
    registerUserWithBillingAction,
    registerUserWithoutPlanAction,
    getStripeSettingAction,
    getHearAboutUsAction,
    getBillingSettingAction,
    registerInvitedAccounowner,
    getStripeKeyAction,
  }
)(Register);
